import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('recovery_ai')

// Tab-generic locked state: shown in place of a tab body when RecoveryAI is
// not active (not onboarded, or operating_mode 'off'). Mirrors the per-pane
// locked message (EscalationRulesPane) but gates whole tabs — the Agent Tuning
// and Settings tabs have no active-state guard of their own. role="status" so
// the swap is announced when a tab is opened while inactive.
const TabLockedMessage = () => {
  const [css] = useStyletron()
  return (
    <div className={`p-l ${css({ textAlign: 'center' })}`} role="status">
      <Text.BodyText3 color="grey70">{t('tab_locked')}</Text.BodyText3>
    </div>
  )
}

export default TabLockedMessage
